
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer",
      function () {
        return require("private-next-pages/soccer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer"])
      });
    }
  